import moment from 'moment-timezone';

export const dev_env = false;
export const api_version = 1;
export const server = dev_env ? 'http://globaldata.local.192.168.4.40.nip.io' : 'https://globaldata.link';

export default {
    dev_env: dev_env,
    version: api_version,
    server: server,
    url: `${server}/api/v${api_version}`
}
